import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useContactAgent = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const axios = useAxios("investor");
  const { t } = useTranslation();
  const urlKey = t("contact-agent");
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { pubPropertyId: string; date: string }) => {
      const response = await axios.post(urlKey, data);
      return response.data;
    },
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (err) => {
      if (onError) {
        onError(err);
      }
    }
  });
};
